import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Activities_Left from './Activities_Left'

import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'


function Festivals() {

    const [HoliOpen, setHoli] = useState(true);
    const [DiwaliOpen, setDiwali] = useState(false);
    const [OnamOpen, setOnam] = useState(false);
    const [JanmastamiOpen, setJanmastami] = useState(false);
    const [GaneshChaturthiOpen, setGaneshChaturthi] = useState(false);
    const [PreChristmasOpen, setPreChristmas] = useState(false);

    const handleClick = (event) => {
        setHoli(false);
        setDiwali(false);
        setOnam(false);
        setJanmastami(false);
        setGaneshChaturthi(false);
        setPreChristmas(false);   
        event(true);
    }



    const HoliImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Holi/1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Holi/2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Holi/3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Holi/4.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Holi/5.jpg" }
    ]




    const DiwaliImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/4.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/5.jpg" },
        
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/7.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/8.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/9.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/10.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/11.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/12.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/13.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Diwali/6.jpg" },

    ]

    const OnamImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Onam/1.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Onam/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Onam/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Onam/4.png" },
               
    ]

    const JanmastamiImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Janmastami/1.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Janmastami/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Janmastami/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Janmastami/4.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Janmastami/5.png" },
       

    ]

    const GaneshChaturthiImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Ganesh_Chaturthi/1.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Ganesh_Chaturthi/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Ganesh_Chaturthi/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Ganesh_Chaturthi/4.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Ganesh_Chaturthi/5.png" },
        

    ]

    const PreChristmasImg = [
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Pre-Christmas/4.png" },
        
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Pre-Christmas/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Pre-Christmas/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Pre-Christmas/1.png" },
        
    ]



    return (

        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Festival" />



            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <div className="c-heading">
                                <h3>Festival</h3> <br />
                            </div>

                            <Col md={3} className='c-left custom-padding-color mb-5'>
                                <Activities_Left activeIndex={5} />
                            </Col>

                            <Col md={9} className='c-right'>
               
                                <Row className='mb-5 text-center'>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button'
                                            onClick={() => handleClick(setHoli)}
                                            aria-controls="example-fade-text"
                                            aria-expanded={HoliOpen}>
                                           HOLI
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setDiwali)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={DiwaliOpen}>
                                           DIWALI
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setOnam)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={OnamOpen}>
                                           Onam
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setJanmastami)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={JanmastamiOpen}>
                                           Janmastami
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setGaneshChaturthi)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={GaneshChaturthiOpen}>
                                           Ganesh Chaturthi
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setPreChristmas)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={PreChristmasOpen}>
                                           Pre-Christmas
                                        </Button>
                                    </Col>


                            

                                </Row>


                                {/*dates */}
                                <div>
                                    {HoliOpen && <Fade in={HoliOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery - HOLI</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {HoliImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>



                                        </div>
                                    </Fade>
                                    }
                                </div>


                                {/*Guidelines*/}

                                <div>
                                    {DiwaliOpen && <Fade in={DiwaliOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery - DIWALI</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {DiwaliImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>

                                <div>
                                    {OnamOpen && <Fade in={OnamOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery - Onam</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {OnamImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>

                                <div>
                                    {JanmastamiOpen && <Fade in={JanmastamiOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery - Janmastami</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {JanmastamiImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>

                                <div>
                                    {GaneshChaturthiOpen && <Fade in={GaneshChaturthiOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery - Ganesh Chaturthi</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {GaneshChaturthiImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>

                                <div>
                                    {PreChristmasOpen && <Fade in={PreChristmasOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery - Pre-Christmas</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {PreChristmasImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>


                                
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Festivals;
